export const DEFAULT_SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'start',
  inline: 'start',
};

export const LABEL = 'Scroll To Element Button';
